export default {
  methods: {
    redirect (response) {
      console.log("redirect");
      const currentUrl = window.location.href;
      const secureUrl = currentUrl.replace("http://", "https://");
      window.location.href = secureUrl;
    }
  }
}
